// Mock data for Think Mechanic Landing Page

export const mockServices = [
  {
    id: 1,
    title: "Engine Diagnostics & Repair",
    description: "Complete engine diagnostics and repair services for all German car brands using state-of-the-art equipment.",
    icon: "wrench"
  },
  {
    id: 2,
    title: "Transmission Services",
    description: "Expert transmission repair and maintenance for automatic and manual transmissions.",
    icon: "settings"
  },
  {
    id: 3,
    title: "Brake System Service",
    description: "Professional brake inspection, repair, and replacement services to ensure your safety.",
    icon: "disc"
  },
  {
    id: 4,
    title: "Electrical Systems",
    description: "Advanced diagnostic and repair of electrical systems, sensors, and onboard computers.",
    icon: "zap"
  },
  {
    id: 5,
    title: "Suspension & Steering",
    description: "Complete suspension and steering system diagnosis and repair for optimal handling.",
    icon: "move"
  },
  {
    id: 6,
    title: "Oil Change & Maintenance",
    description: "Regular maintenance services including oil changes, filter replacements, and fluid checks.",
    icon: "droplet"
  }
];

export const mockGermanBrands = [
  { name: "BMW", logo: "bmw" },
  { name: "Mercedes-Benz", logo: "mercedes" },
  { name: "Audi", logo: "audi" },
  { name: "Porsche", logo: "porsche" },
  { name: "Volkswagen", logo: "volkswagen" }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Michael Schmidt",
    car: "BMW M5",
    rating: 5,
    text: "Exceptional service! They fixed my BMW's transmission issue that other shops couldn't diagnose. Highly recommended!"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    car: "Audi A6",
    rating: 5,
    text: "Professional and honest mechanics. They explained everything clearly and the pricing was fair."
  },
  {
    id: 3,
    name: "David Chen",
    car: "Mercedes C-Class",
    rating: 5,
    text: "Best German car specialists in town! My Mercedes runs like new after their service."
  }
];

export const mockBookingSlots = [
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "01:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM"
];

// Mock booking submission
export const submitBooking = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Booking submitted:", bookingData);
      resolve({
        success: true,
        message: "Booking confirmed! We'll contact you shortly.",
        bookingId: `BK${Date.now()}`
      });
    }, 1000);
  });
};
